import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function ComparisonTable() {
  const rows = [{
    feature: 'Quoted by the owner personally',
    langler: true,
    wholesaler: false,
    discount: false
  }, {
    feature: 'Fixed price in writing, no surprises',
    langler: true,
    wholesaler: false,
    discount: false
  }, {
    feature: 'Mitsubishi Diamond Dealer accredited',
    langler: true,
    wholesaler: false,
    discount: false
  }, {
    feature: 'Same family, same workshop, 30+ years',
    langler: true,
    wholesaler: false,
    discount: false
  }, {
    feature: 'Lifetime workmanship guarantee',
    langler: true,
    wholesaler: false,
    discount: false
  }, {
    feature: 'Clean install promise (drop sheets, vacuum)',
    langler: true,
    wholesaler: false,
    discount: false
  }, {
    feature: 'Same business day callback',
    langler: true,
    wholesaler: false,
    discount: false
  }, {
    feature: 'Picks up the phone after install',
    langler: true,
    wholesaler: false,
    discount: false
  }];
  return <section className="bg-cream py-20 md:py-28" data-id="element-90">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-91">
        <div className="max-w-3xl mb-12" data-id="element-92">
          <div className="kicker mb-3" data-id="element-93">Compare honestly</div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold text-ink-900 tracking-tight leading-tight" data-id="element-94">
            Langler Air vs the other guys.
          </h2>
          <p className="mt-4 text-lg text-stone-600" data-id="element-95">
            Fair question. Honest answer.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-2xl border border-stone-200 overflow-hidden shadow-lg" data-id="element-96">
          <div className="overflow-x-auto" data-id="element-97">
            <div className="min-w-[600px]" data-id="element-98">
              {/* Header row */}
              <div className="grid grid-cols-[2fr_1fr_1fr_1fr] sticky left-0" data-id="element-99">
                <div className="p-5" data-id="element-100"></div>
                <div className="p-5 bg-brand text-white text-center" data-id="element-101">
                  <div className="text-[10px] uppercase tracking-wider font-bold opacity-80 mb-1" data-id="element-102">
                    Us
                  </div>
                  <div className="font-display text-base font-extrabold" data-id="element-103">
                    Langler Air
                  </div>
                </div>
                <div className="p-5 text-center border-l border-stone-200" data-id="element-104">
                  <div className="text-[10px] uppercase tracking-wider font-bold text-stone-500 mb-1" data-id="element-105">
                    Them
                  </div>
                  <div className="font-display text-base font-extrabold text-stone-700" data-id="element-106">
                    Wholesalers
                  </div>
                </div>
                <div className="p-5 text-center border-l border-stone-200" data-id="element-107">
                  <div className="text-[10px] uppercase tracking-wider font-bold text-stone-500 mb-1" data-id="element-108">
                    Them
                  </div>
                  <div className="font-display text-base font-extrabold text-stone-700" data-id="element-109">
                    Discount Installers
                  </div>
                </div>
              </div>

              {rows.map((row, i) => <div key={i} className="grid grid-cols-[2fr_1fr_1fr_1fr] border-t border-stone-200 hover:bg-cream-100 transition-colors" data-id="element-110">
                  <div className="p-4 text-sm font-medium text-ink-900" data-id="element-111">
                    {row.feature}
                  </div>
                  <div className="p-4 flex items-center justify-center bg-brand/5" data-id="element-112">
                    <Check size={20} className="text-brand" strokeWidth={3} data-id="element-113" />
                  </div>
                  <div className="p-4 flex items-center justify-center border-l border-stone-200" data-id="element-114">
                    <X size={20} className="text-stone-400" strokeWidth={2.5} data-id="element-115" />
                  </div>
                  <div className="p-4 flex items-center justify-center border-l border-stone-200" data-id="element-116">
                    <X size={20} className="text-stone-400" strokeWidth={2.5} data-id="element-117" />
                  </div>
                </div>)}
            </div>
          </div>
        </motion.div>

        <p className="mt-6 text-sm text-stone-500 max-w-3xl" data-id="element-118">
          We're not always the cheapest on the unit. We are, almost always, the
          cheapest over 10 years, because right-sized systems run less and last
          longer.
        </p>
      </div>
    </section>;
}